import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

/**
 * Suivi Google Analytics 4 pour SPA (Emplois BNSSA & MNS).
 *
 * - Envoie un évènement `page_view` à chaque changement de route
 *   (pathname + search + hash).
 * - Le snippet gtag.js est chargé dans index.html avec `send_page_view: false`
 *   pour éviter le double comptage de la première vue.
 * - Le tracking passe par `trackEvent` (lib centralisée), qui gère la
 *   déduplication courte fenêtre, la queue tampon (si gtag pas encore prêt)
 *   et l'exécution non-bloquante via requestIdleCallback.
 */
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const pageLocation = `${window.location.origin}${pagePath}`;

    trackEvent("page_view", {
      page_path: pagePath,
      page_location: pageLocation,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default Analytics;
